import React from "react";
import NuMultiSelect from "./NuMultiSelect";
import NuSingleSelect from "./NuSingleSelect";
import StandardModal from "./shared/StandardModal";
import moment from "moment";
import { PrimaryButton } from "./shared/button/PrimaryButton";
import { SecondaryButton } from "./shared/button/SecondaryButton";
import { useClassroomPolicyStore } from "stores/v2/classroomPolicyStore";

export default class RewardModal extends React.Component {
	constructor(props) {
		super(props);
		this.state = {
			reward_apps:
				useClassroomPolicyStore.getState().getRewardApps().length > 0
					? useClassroomPolicyStore.getState().getRewardApps()
					: ["sphirewall.application.socialmedia", "sphirewall.application.gaming"],
			reward_websites:
				useClassroomPolicyStore.getState().getRewardWebsites().length > 0 ? useClassroomPolicyStore.getState().getRewardWebsites() : [],
			reward_active_until: useClassroomPolicyStore.getState().getRewardActiveUntil()
				? useClassroomPolicyStore.getState().getRewardActiveUntil()
				: 0,
			timeframe: "600",
			active: false,
		};
	}

	componentDidMount = () => {
		this.timer = setInterval(this.reward_timer, 1000);
	};

	componentWillUnmount = () => {
		clearInterval(this.timer);
	};

	reset = () => {
		this.setState({
			reward_apps: ["sphirewall.application.socialmedia", "sphirewall.application.gaming"],
			reward_websites: [],
			reward_active_until: 0,
			timeframe: "600",
		});
	};

	startReward = (event) => {
		const activeUntil = moment().unix() + parseInt(this.state.timeframe);
		this.setState({
			reward_active_until: activeUntil,
		});
		useClassroomPolicyStore.getState().setReward({
			apps: this.state.reward_apps,
			websites: this.state.reward_websites,
			active_until: activeUntil,
		});
		this.handleClose();
	};

	updateReward = (event) => {
		useClassroomPolicyStore.getState().setReward({
			apps: this.state.reward_apps,
			websites: this.state.reward_websites,
			active_until: this.state.reward_active_until,
		});
		this.handleClose();
	};

	stopReward = (event) => {
		this.reset();
		useClassroomPolicyStore.getState().setReward({
			apps: [],
			websites: [],
			active_until: 0,
			timeframe: "600",
		});
		this.handleClose();
	};

	handleClose = () => {
		this.props.onClose();
	};

	prepareSignatures = () => {
		const ret = [];
		const availableSignatures = this.props.signatureDb.signatures;
		availableSignatures.sort(function (a, b) {
			return a.name.localeCompare(b.name);
		});

		for (const signature of availableSignatures) {
			if (
				signature.enabled &&
				signature.id !== "sphirewall.application.porn" &&
				signature.id !== "sphirewall.application.childporn" &&
				signature.id !== "sphirewall.application.offensive"
			) {
				ret.push({ value: signature.id, text: signature.name });
			}
		}

		ret.push({
			shouldShow: function (value) {
				return this.isOk(value);
			},
			renderText: function (value) {
				return "Website " + value;
			},
			isOk: function (value) {
				return this.transformFilter(value) !== "";
			},
			transformFilter: function (value) {
				const re = /^(http:\/\/|https:\/\/|)([a-z0-9A-Z.]+\.?)\.([a-z0-9A-Z.]+)(\/|)([a-z0-9A-Z.\-%_#&?=]+|)/i;
				let url = "";
				if (re.test(value)) {
					const m = re.exec(value);
					if (m[2] !== "") {
						url += m[2];
					}
					if (m[3] !== "") {
						url += "." + m[3];
					}
					if (m[4] !== "") {
						url += m[4];
					}
					if (m[5] !== "") {
						url += m[5];
					}
				}
				return url;
			},
			dynamic: true,
			value: "website",
		});

		return ret;
	};

	processSelectedItems = () => {
		const ret = [];
		for (const x of this.state.reward_apps) {
			ret.push(x);
		}

		for (const x of this.state.reward_websites) {
			ret.push(x);
		}
		return ret;
	};

	handleAddRewardApp = (tag) => {
		if (this.props.signatureDb.find(tag) !== undefined) {
			this.setState({
				reward_apps: this.state.reward_apps.concat([tag]),
			});
		} else {
			this.setState({
				reward_websites: this.state.reward_websites.concat([tag]),
			});
		}
	};

	handleRemoveRewardApp = (tag) => {
		if (this.props.signatureDb.find(tag) !== undefined) {
			const tmpRewardApps = this.state.reward_apps;
			const index = tmpRewardApps.indexOf(tag);
			if (index >= 0) {
				tmpRewardApps.splice(index, 1);
				this.setState({
					reward_apps: tmpRewardApps,
				});
			}
		} else {
			const tmpRewardWebsites = this.state.reward_websites;
			const index = tmpRewardWebsites.indexOf(tag);
			if (index >= 0) {
				tmpRewardWebsites.splice(index, 1);
				this.setState({
					reward_websites: tmpRewardWebsites,
				});
			}
		}
	};

	prepareRewardDuration = () => {
		const ret = [];
		ret.push({ value: "600", text: "For 10 Minutes" });
		ret.push({ value: "900", text: "For 15 Minutes" });
		ret.push({ value: "1200", text: "For 20 Minutes" });
		ret.push({ value: "1800", text: "For 30 Minutes" });
		ret.push({ value: "2700", text: "For 45 Minutes" });
		ret.push({ value: "3600", text: "For 1 Hour" });
		ret.push({ value: "7200", text: "For 2 Hour" });
		ret.push({ value: "10800", text: "For 3 Hour" });
		return ret;
	};

	changeRewardDuration = (value) => {
		this.setState({
			timeframe: value,
		});
	};

	reward_timer = () => {
		const active = this.state.reward_active_until > moment().unix();
		const end = moment.utc(this.state.reward_active_until, "X");
		const timeLeft = moment.utc(end.diff(moment.utc()));
		if (this.state.active !== active) {
			this.setState({
				active: active,
				// rewardTimeLeft: timeLeft.hours() + " hours " + timeLeft.minutes() + " minutes"
			});
			if (this.props.isActive) {
				this.props.isActive(active);
			}
		}
		const rewardTTL = document.getElementById("rewardTimeLeft");
		if (rewardTTL) {
			rewardTTL.innerText = timeLeft.format("HH:mm:ss");
		}
	};

	renderActions = () => {
		if (this.state.active) {
			return (
				<React.Fragment>
					<SecondaryButton className="mui-flat-button secondary_btn" label="Stop" onClick={this.stopReward} />
					<PrimaryButton className="mui-flat-button" label="Update" onClick={this.updateReward} />
				</React.Fragment>
			);
		}
		return (
			<React.Fragment>
				<PrimaryButton className="mui-flat-button" label="Start" onClick={this.startReward} />
			</React.Fragment>
		);
	};

	renderTimeSelection = () => {
		if (this.state.active) {
			return (
				<div>
					Time Left: <span id={"rewardTimeLeft"} /> ({moment(this.state.reward_active_until, "X").format("LLL")})
				</div>
			);
		} else {
			return (
				<NuSingleSelect
					allItems={this.prepareRewardDuration()}
					selectedItem={this.state.timeframe}
					searchPlaceholder="Reward duration"
					title="Reward duration"
					onChange={this.changeRewardDuration}
				/>
			);
		}
	};

	render() {
		return (
			<StandardModal size="medium" actions={this.renderActions()} open={this.props.open} close={this.handleClose}>
				<form onSubmit={(ev) => ev.preventDefault()}>
					<div>{this.renderTimeSelection()}</div>
					<br />
					<div>
						<NuMultiSelect
							allItems={this.prepareSignatures()}
							selectedItems={this.processSelectedItems()}
							searchPlaceholder="Search for reward applications/websites"
							selectedPlaceholder="No reward applications/websites selected"
							onAdd={this.handleAddRewardApp}
							onRemove={this.handleRemoveRewardApp}
							title="Applications and websites"
						/>
					</div>
				</form>
			</StandardModal>
		);
	}
}
